import { z } from "zod";
import { phoneSchema } from "../common/phone.js";
import { userRoleSchema } from "./user-role.js";
export const updateUserSchema = z.object({
    first_name: z.string().min(1).max(100).optional(),
    last_name: z.string().min(1).max(100).optional(),
    phone: phoneSchema,
    address: z.string().optional(),
    role: userRoleSchema.optional(),
    company_name: z.string().max(200).optional(),
    company_siret: z
        .string()
        .regex(/^\d{14}$/, "SIRET invalide (14 chiffres)")
        .or(z.literal(""))
        .optional(),
    company_vat_number: z.string().max(30).optional(),
    company_address: z.string().max(300).optional(),
    company_iban: z
        .string()
        .regex(/^[A-Z]{2}\d{2}[A-Z0-9]+$/i, "IBAN invalide")
        .or(z.literal(""))
        .optional(),
    signature_url: z.url().or(z.literal("")).nullable().optional(),
});
